import styled from 'styled-components';

const FooterStyle = styled.footer`
	--footerFirstContentPadTopBot: var(--sp15x);
	--logoWidth: var(--sp55x);
	--logoHeight: var(--sp6x);
	--columnWidth: calc(33.3% - ((2 * var(--colPadding)) / 3));
	--columnTitleDistance: var(--sp4x);
	--columnItemLargeDistance: var(--sp2x);
	--columnItemSmallDistance: var(--sp1x);
	--footerLastContentPadTop: var(--sp4x);
	--footerLastContentPadBot: var(--sp6x);

	--socialsMTop: var(--sp6x);
	--socialsGap: var(--sp3x);
	--iconSize: var(--sp4x);

	--applicationButtonMTop: var(--sp2x);
	--applicationButtonMBottom: var(--sp1x);

	position: relative;
	padding: 0 var(--contPaddingLR);
	background-color: var(--neutral1000);
	z-index: 999999;

	.application-button-wrapper {
		margin: var(--applicationButtonMTop) 0 var(--applicationButtonMBottom) 0;
	}

	.footer-first-container {
		padding: var(--footerFirstContentPadTopBot) 0;
		border-top: 2px solid var(--neutral600);
		border-bottom: 2px solid var(--neutral600);
	}

	.left-block {
		display: flex;
		flex-direction: column;
	}

	.logo-block {
		--proportion: 0;

		width: var(--logoWidth);
		background-color: transparent !important;

		img {
			position: relative !important;
			object-fit: contain !important;
		}
	}

	.socials-block {
		display: flex;
		flex-wrap: wrap;
		gap: var(--socialsGap);
		margin-top: var(--socialsMTop);

		i {
			display: block;
			font-size: var(--iconSize);
			transition: transform var(--trTime) ease-out;

			@media (pointer: fine) {
				@media (hover: hover) {
					&:hover {
						transform: scale(1.3);
					}
				}
			}
		}
	}

	.right-block {
		display: flex;
		flex-wrap: wrap;
		gap: var(--colPadding);
	}

	.block {
		width: var(--columnWidth);
		display: flex;
		flex-direction: column;

		&.title {
			gap: var(--columnTitleDistance);
		}

		&.large {
			gap: var(--columnItemLargeDistance);
		}
	}

	.width-fit-content {
		width: fit-content;
	}

	.flex-block {
		display: flex;
		flex-direction: column;
		width: fit-content;

		&.large {
			gap: var(--columnItemLargeDistance);
		}

		&.small {
			gap: var(--columnItemSmallDistance);
		}
	}

	.footer-last-container {
		padding-top: var(--footerLastContentPadTop);
		padding-bottom: var(--footerLastContentPadBot);
	}

	.color-hover {
		transition: color var(--trTime) ease-out;

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					color: var(--pink1000);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--footerFirstContentPadTopBot: var(--sp10x);
		--logoWidth: var(--sp44x);
		--logoHeight: var(--sp6x);
		--footerLastContentPadTop: var(--sp3x);
		--footerLastContentPadBot: var(--sp4x);

		--socialsMTop: var(--sp4x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--footerFirstContentPadTopBot: var(--sp8x);
		--logoWidth: var(--sp37x);
		--logoHeight: var(--sp5x);

		--iconSize: var(--sp3-5x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--logoWidth: var(--sp33x);
		--logoHeight: var(--sp4-5x);
		--columnTitleDistance: var(--sp3x);
		--columnItemLargeDistance: var(--sp1-5x);

		--iconSize: var(--sp3x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--footerFirstContentPadTopBot: var(--sp6x);
		--logoWidth: var(--sp33x);
		--logoHeight: var(--sp4-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--footerFirstContentPadTopBot: var(--sp7x);
		--columnWidth: calc(50% - (var(--colPadding) / 2));
		--logoWidth: var(--sp28x);
		--logoHeight: var(--sp4x);
		--footerLastContentPadTop: var(--sp2x);
		--footerLastContentPadBot: var(--sp3x);

		--blockLastChildDistance: var(--sp5x);

		.block {
			&:last-child {
				margin-top: var(--blockLastChildDistance);
			}
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--footerFirstContentPadTopBot: var(--sp4x);
		--logoWidth: var(--sp43x);
		--logoHeight: var(--sp6x);
		--footerLastContentPadTop: var(--sp2x);
		--footerLastContentPadBot: var(--sp3x);

		--blockLastChildDistance: var(--sp3x);

		.logo-block {
			max-width: var(--logoWidth);
			width: auto;
		}

		.right-block {
			margin-top: var(--sp5x);
		}

		.mt-16 {
			margin-top: var(--sp2x);
		}
	}
`;

export default FooterStyle;
